import ItemBuilderSFC from "./ItemBuilder.vue";
export const ItemBuilder = ItemBuilderSFC;
